import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/HomeView.vue";
import AboutView from "../views/project/AboutView.vue";
import forkliftList from "../views/project/forklift/forkliftList.vue";
import forkliftDetail from "../views/project/forklift/forkliftDetail.vue";
import forkliftDetailOnWay from "../views/project/forklift/forkliftDetailOnWay.vue";
import accessoriyList from "../views/project/accessoriy/accessoriyList.vue";
import accessoriyDetail from "../views/project/accessoriy/accessoriyDetail.vue";
import newsList from "../views/project/news/newsList.vue";
import newsDetail from "../views/project/news/newsDetail.vue";
import favorite from "../views/project/favorite.vue";
import compare from "../views/project/compare.vue";
import login from "../views/project/Login.vue";
import register from "../views/project/register.vue";
import conctact from "../views/project/contact.vue";
import userInfo from "../views/project/userInfo.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/forkliftList",
    name: "home",
    component: HomeView,
    children: [
      {
        path: "/forkliftList",
        meta: {
          keepAlive: true,
        },
        name: "forkliftList",
        component(resolve) {
          require(["../views/project/forklift/forkliftList.vue"], resolve);
        },
      },
      {
        path: "/forkliftListOnWay",
        meta: {
          keepAlive: true,
        },
        name: "forkliftListOnWay",
        component(resolve) {
          require(["../views/project/forklift/forkliftListOnWay.vue"], resolve);
        },
      },
      {
        path: "/AboutView",
        name: "AboutView",
        component: AboutView,
      },
      {
        path: "/forkliftDetail",
        name: "forkliftDetail",
        component: forkliftDetail,
      },
      {
        path: "/forkliftDetailOnWay",
        name: "forkliftDetailOnWay",
        component: forkliftDetailOnWay,
      },
      {
        path: "/accessoriyList",
        meta: {
          keepAlive: true,
        },
        name: "accessoriyList",
        component(resolve) {
          require(["../views/project/accessoriy/accessoriyList.vue"], resolve);
        },
      },
      {
        path: "/accessoriyDetail",
        name: "accessoriyDetail",
        component: accessoriyDetail,
      },
      {
        path: "/favorite",
        name: "favorite",
        component: favorite,
      },
      {
        path: "/compare",
        name: "compare",
        component: compare,
      },
      {
        path: "/login",
        name: "login",
        component: login,
      },
      {
        path: "/register",
        name: "register",
        component: register,
      },
      {
        path: "/contact",
        name: "contact",
        component: conctact,
      },
      {
        path: "/newsList",
        name: "newsList",
        component: newsList,
      },
      {
        path: "/newsDetail",
        name: "newsDetail",
        component: newsDetail,
      },
      {
        path: "/userInfo",
        name: "userInfo",
        component: userInfo,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
//控制重复点击相同路由   2024/05/06 BY lixiaolong
const VueRouterPush = router.push;
router.push = function push(to) {
  undefined;
  return VueRouterPush.call(this, to).catch((err) => err);
};
export default router;
